import { QueryClient } from "@tanstack/react-query";

export const createQueryClient = () => {
  return new QueryClient()
}
